import { render } from "./Alien.vue?vue&type=template&id=4a628620&scoped=true"
import script from "./Alien.vue?vue&type=script&lang=js"
export * from "./Alien.vue?vue&type=script&lang=js"

import "./Alien.vue?vue&type=style&index=0&id=4a628620&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4a628620"

export default script